import React from 'react';

export default function PageNotFound() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <h3>Page not found.</h3>
    </div>
  );
}
